import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import SuccessIcon from "../../../assets/images/success-icon.svg";
import WarningIcon from "../../../assets/images/red-warning.svg";
import GlobalStyles from "../../../assets/js/globalStyles";

class ErrorContainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes } = this.props;
    return (
      <div id="error">
        {this.props.errorStatus && (
          <p className={`text-center d-flex p-2 ${this.props.errorStyle}`}>
            <img
              src={WarningIcon}
              alt="warning"
              className={classes.errorIcon}
            />
            {this.props.errorMsg}
          </p>
        )}
        {this.props.updateStatus && (
          <p className={`text-center d-flex p-2 ${this.props.successStyle}`}>
            <img
              src={SuccessIcon}
              alt="success"
              className={classes.errorIcon}
            />
            {this.props.successMsg}
          </p>
        )}
      </div>
    );
  }
}

export default withStyles(GlobalStyles)(ErrorContainer);
